import Area from './area';
import UIBuilder from '../BaseComponent';
import { UI_COMPONENTS_TYPE_FIELD } from '../../../../Constant/Constant';

export default class AreaBuilder extends UIBuilder {
  constructor() {
    super();
    this.schema = {
      area: UI_COMPONENTS_TYPE_FIELD.JSON,
    };
  }

  getType = () => {
    return 'area';
  };

  getComponent = () => {
    return Area;
  };
}
